import './select2.css';
import './select2';
import './select2_locale_ru';